<template>
  <div class="d-flex justify-content-between text-center w-100">
    <span class="flex-0 text-start" style="cursor: pointer" @click="decrement(route, routePrefix)">
      <i class="bi bi-arrow-down small text-danger"></i>
    </span>
    <span class="flex-grow-1">{{ localValue }}</span>
    <span class="flex-0 text-end" style="cursor: pointer" @click="increment(route, routePrefix)">
      <i class="bi bi-arrow-up small text-success"></i>
    </span>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';

export default {
  props: {
    id: { type: Number, default: null },
    column: { type: String, default: null },
    resourceType: { type: String, default: null },
    requestType: { type: String, default: 'api' },
    value: { type: Number, default: 0 },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValue = ref(props.value);

    const decrement = (route, routePrefix) => {
      localValue.value--;
      updateData(route, routePrefix);
    };

    const increment = (route, routePrefix) => {
      localValue.value++;
      updateData(route, routePrefix);
    };

    const updateData = (route, routePrefix) => {
      if (props.requestType == 'api') {
        emit('update:data', getParams());
      } else {
        router.patch(route(`${routePrefix}.${props.resourceType}.update`, getParams()), getParams(), {});
      }
    };

    const getParams = () => {
      let params = { id: props.id };
      params[props.column] = localValue.value;

      return params;
    };

    return {
      decrement,
      increment,
      getParams,
      localValue,
    };
  },
};
</script>
